import React from 'react';
import { DataGridCell } from '@thd-olt-component-react/data-grid';
import { MoreButton } from '@thd-olt-component-react/project-forms';
import { Typography, Link, Badge } from '@one-thd/sui-atomic-components';
import { Apron } from '@one-thd/sui-icons';
import {
  PROJECT_STATUS_ACTIVE,
  PROJECT_STATUS_ARCHIVED,
  SORT_KEY_PROJECT_ID,
  SORT_KEY_PROJECT_STATUS,
  SORT_KEY_PROJECT_NAME,
  SORT_KEY_LAST_MODIFIED
} from '../project-summary-helper';

export const createColumns = (getColumnSortValue) => {

  const columns = [
    {
      title: 'Project Name',
      key: SORT_KEY_PROJECT_NAME,
      enableSorting: true,
      align: 'left',
      renderCell: ({ item }) => (
        <DataGridCell>
          <div className="sui-py-2 sui-pl-2 sui-w-72">
            <Typography truncate>
              <Link href={item.url}>{item.projectName}</Link>
            </Typography>
          </div>
        </DataGridCell>
      ),
      renderHeader: ({ title }) => (
        <div className="sui-pt-3 sui-pb-3">
          <Typography weight="bold">
            {title}
          </Typography>
        </div>
      ),
      sortBy: getColumnSortValue(SORT_KEY_PROJECT_NAME)
    },
    {
      title: 'Project  Number',
      key: SORT_KEY_PROJECT_ID,
      enableSorting: true,
      align: 'left',
      renderCell: ({ item }) => (
        <DataGridCell>{item.projectNumber}</DataGridCell>
      ),
      sortBy: getColumnSortValue(SORT_KEY_PROJECT_ID)
    },
    {
      title: 'Status',
      key: SORT_KEY_PROJECT_STATUS,
      enableSorting: true,
      align: 'left',
      renderCell: ({ item }) => (
        <DataGridCell>
          <Badge
            data-testid="badge-status"
            size="small"
            variant="subtle"
            color={item.projectStatus === PROJECT_STATUS_ACTIVE ? 'info' : 'medium'}
          >
            <span className="sui-capitalize">
              {item.projectStatus === PROJECT_STATUS_ACTIVE ? PROJECT_STATUS_ACTIVE : PROJECT_STATUS_ARCHIVED}
            </span>
          </Badge>
        </DataGridCell>
      ),
      sortBy: getColumnSortValue(SORT_KEY_PROJECT_STATUS)
    },
    {
      title: 'Last Modified',
      key: SORT_KEY_LAST_MODIFIED,
      enableSorting: true,
      align: 'left',
      renderCell: ({ item }) => {
        return (
          <DataGridCell>
            <Typography data-testid="last-modified-value">{item.lastModified}</Typography>
          </DataGridCell>
        );
      },
      sortBy: getColumnSortValue(SORT_KEY_LAST_MODIFIED)
    },
    {
      title: 'Created By',
      key: 'createdBy',
      enableSorting: false,
      align: 'left',
      renderCell: ({ item }) => (
        <DataGridCell>
          {item.isCreatedByTHDAssociate
            ? (
              <div className="sui-flex sui-items-baseline">
                <div className="sui-mr-2"><Apron color="brand" size="small" /></div>
                <Typography>THD Associate</Typography>
              </div>
            )
            : <Typography>{item.createdBy}</Typography>}
        </DataGridCell>
      ),
      sortBy: getColumnSortValue('createdBy')
    },
    {
      title: '',
      key: 'dropdown',
      endableSorting: false,
      align: 'center',
      renderCell: ({ item }) => (
        <DataGridCell>
          <div className="sui-flex sui-justify-center">
            <MoreButton
              projectStatus={item.projectStatus}
              projectName={item.projectName}
              projectId={item.id}
              isProHouseProject={item?.hasTradeCreditAttached ?? false}
            />
          </div>
        </DataGridCell>
      )
    }
  ];
  return columns;
};